"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteBucketInventoryConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=DeleteBucketInventoryConfigurationOutput.js.map